// extracted by mini-css-extract-plugin
export var activePage = "styles-mod--active-page--a807b";
export var disablePaginationItem = "styles-mod--disable-pagination-item--03e8f";
export var paginationContainer = "styles-mod--pagination-container--47992";
export var paginationItem = "styles-mod--pagination-item--2af13";